import React, { useContext, useEffect, useState } from 'react';
import './conceptSection.module.scss';
import { SpBr } from '../../../../commonv3/components/atoms/layouts/br';
import 'intersection-observer';
import { useVisibilityHandler } from '../../../../commonv3/hooks/useVisibilityHandler';
import { PageSection, TitlelessPageSection } from '../PageSection';
import { TrialLpContext, TrialSectionContext } from '../../../contexts/trial';
import { loadImage, TrialSections } from '../state/TrialResourceState';
import BackgroundSp from './images/bg_concept_sp.png';

const CONCEPT_PRIORITY = 0;

export const ConceptSection = ({ onVisibilityChange }) => {
    const context = useContext(TrialLpContext);
    const [ref, setRef] = useState(null);
    useVisibilityHandler(ref, onVisibilityChange);
    useEffect(() => {
        context.resource.request(TrialSections.CONCEPT, () => loadImage(BackgroundSp), CONCEPT_PRIORITY);
    }, []);
    return (
        <TitlelessPageSection id={TrialSections.CONCEPT} styleName="section" setRef={setRef}>
            <div styleName="section-inner">
                <div styleName="title">
                    私のきっかけは、<br />ここにある。
                </div>
                <div styleName="body">
                    好きな色より、周りに馴染む色<br />
                    華やかで大きな花より、無難な小ぶりの花<br />
                    <br />
                    そうやって、「私にはこれくらいが丁度良い」って選んだ花は<br />
                    本当にあなたが心から咲かせたい花ですか？<br />
                    <br />
                    一度しかない私の人生、<br />
                    人目や常識にとらわれないで、<br />
                    本当はもっと大胆に咲き誇りたい<br />
                    <br />
                    そんな心の声に、蓋をしないで<br />
                    まだ心の中にしかない夢の花でも、<br />
                    その蕾はすでにあなたの手のひらの中<br />
                    <br />
                    SHEと一緒に、<br />
                    光の射す温かな環境で<br />
                    水をあげて、肥料をあげて、<br />
                    ときには優しい言葉をかけて<br />
                    <br />
                    私らしい輝かしい花を、<SpBr />満開に咲かせる人生を
                </div>
            </div>
        </TitlelessPageSection>
    );
};
